import Toggle from 'components/partials/toggle/toggle';
import Loader from 'components/partials/loader/loader';
import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import Button from 'components/partials/button/button';
import { getInsightUsersTableSettings } from 'components/partials/insight-modal/components/user-access-step/user-access-step.config';
import { useInsightAccess } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/hooks/use-insight-access';

import type { InsightDto } from 'api/generated/schemas/insightDto';

interface AccessTabProps {
  insight: InsightDto | null | undefined;
  clientId: string | number | undefined;
}

const AccessTab = ({
  insight,
  clientId,
}: AccessTabProps): React.JSX.Element => {
  const {
    loading,
    saving,
    displayedData,
    isAllUsersSelected,
    isIndeterminate,
    isToggleOn,
    hasChanges,
    onSelectAllUsers,
    onUserChange,
    onToggleChange,
    handleSave,
    handleCancel,
  } = useInsightAccess({ insight, clientId });

  const columns = getInsightUsersTableSettings({
    onUserChange,
    onSelectAllUsers,
    isAllUsersSelected,
    isIndeterminate,
  });

  if (!displayedData.length && !loading) {
    return (
      <EmptySpaceContent
        customClass="flex-1"
        text="No users have been assigned yet"
      />
    );
  }

  return (
    <div className="relative">
      <Loader
        loading={loading || saving}
        customClass="!bg-white"
        fullScreen={false}
      />
      <TableComponent
        columns={columns}
        data={displayedData}
        customHeight="max-h-[500px]"
        pagination={false}
        showingRecordsTextIsOn={false}
        viewByAmountSelectIsOn={false}
        isLoading={loading || saving}
      />

      <div className="flex flex-col items-start justify-start mt-4">
        <Toggle
          onToggleChange={onToggleChange}
          isToggleOn={isToggleOn}
          toggleText="Assign to all new users"
          data-testid="access-tab-toggle"
        />

        {hasChanges && (
          <div className="flex items-center gap-3 mt-5">
            <Button
              variant="brand-filled"
              size="sm"
              onClick={handleSave}
              loading={saving}
              data-testid="update-access-tab-button"
            >
              Update access
            </Button>
            <Button
              variant="reserve-outlined"
              size="sm"
              onClick={handleCancel}
              disabled={saving}
              data-testid="cancel-access-tab-button"
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccessTab;
